module.exports = {
  accountManager: 'ការគ្រប់គ្រងគណនី',
  accountType: 'ប្រភេទ​គណនី',
  mobileValid: 'ការផ្ទៀងផ្ទាត់តាមទូរស័ព្ទ',
  setPhoneFirst: 'សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នកជាមុនសិន',
  phoneValid: 'ការផ្ទៀងផ្ទាត់តាមទូរស័ព្ទ',
  resetPassword: 'កំណត់លេខសំងាត់ម្តងទៀត',
  passwordInconsistent: 'ការកែប្រែបានជោគជ័យ សូមចូលម្តងទៀត',
  pwdEditTips: 'គណនី ឬពាក្យសម្ងាត់របស់អ្នកត្រូវបានកែប្រែ សូមចូលម្តងទៀត ប្រសិនបើវាមិនត្រូវបានធ្វើដោយខ្លួនឯង សូមទាក់ទងផ្នែកបម្រើអតិថិជន',
  change: 'ប្តូរ',
  editPassword: 'កែប្រែលេខសម្ងាត់',
  belongMerchant: 'ឈ្មួញដែលត្រូវគ្នា',
  merchantAccount: 'គណនីពាណិជ្ជករ',
  merchantPassword: 'គណនីពាណិជ្ជករ',
  email: 'អ៊ីមែល',
  storeLoginPhone: 'លេខទូរស័ព្ទហាង',
  userName: 'ឈ្មោះអ្នកប្រើ',
  currentPassword: 'លេខសំងាត់​បច្ចុប្បន្ន',
  newLoginPassword: 'ពាក្យសម្ងាត់ចូលថ្មី',
  editSuccess3s: 'កែប្រែដោយជោគជ័យ 3s ក្រោយមក',
  reLogin: 'ម្តងទៀតចូល',
  complete: 'ចប់',
  changePhoneMustNeedValid: 'ការផ្លាស់ប្តូរទូរស័ព្ទចូលតម្រូវឱ្យមានការផ្ទៀងផ្ទាត់ សូមជ្រើសរើសវិធីសាស្ត្រផ្ទៀងផ្ទាត់',
  phoneNumberValid: 'ការផ្ទៀងផ្ទាត់លេខទូរស័ព្ទ',
  idValid: 'ការផ្ទៀងផ្ទាត់អត្តសញ្ញាណ',
  realName: 'ឈ្មោះពិត',
  credentialsType: 'ប្រភេទឯកសារ',
  credentialsNumber: 'លេខឯកសារ',
  changeLoginPhone: 'ប្តូរទូរស័ព្ទចូល',
  validIsCurrentLoginPhone: 'លេខទូរស័ព្ទដែលបានបញ្ចូលគឺមិនស៊ីគ្នានឹងគណនីចូលបច្ចុប្បន្នទេ។',
  passwordCouldNotIncludeSpace: 'ពាក្យសម្ងាត់មិនអាចរួមបញ្ចូល Space បានទេ'
}
